import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getInterviewFolders = async (data) => {
    return decryptData(
        await axios.get(
            `/get-interview-folders?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};
export const deleteFileFromInterviewFolder = async (data) => {
  return decryptData(
    await axios.post(`/delete-interview-file`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};